/**
 * Single source of truth for public tracking identifiers installed on the site.
 *
 * Rules:
 * - GTM is the only tag hardcoded in the HTML (src/routes/__root.tsx).
 * - Meta Pixel and Google Analytics 4 are loaded *inside* the GTM container,
 *   so their IDs are not declared in the source code. They appear here as
 *   optional values so the admin panel can show them if they are ever added
 *   directly to the code, but by default they are managed via GTM.
 */

export const GTM_CONTAINER_ID = "GTM-PR745X8V";

export const GA4_MEASUREMENT_ID: string | null = null;

export const META_PIXEL_ID: string | null = "2367275056629516";

/**
 * Meta Conversions API (CAPI) shares the Pixel ID; the access token is a
 * server-side secret and never surfaces here. `null` means CAPI is disabled;
 * a string means it's active via GTM using this Pixel ID.
 */
export const META_CAPI_PIXEL_ID: string | null = META_PIXEL_ID;

export interface TrackingIdentifiers {
  gtm: string;
  ga4: string | null;
  pixel: string | null;
  capi: string | null;
}

export function getInstalledTrackingIds(): TrackingIdentifiers {
  return {
    gtm: GTM_CONTAINER_ID,
    ga4: GA4_MEASUREMENT_ID,
    pixel: META_PIXEL_ID,
    capi: META_CAPI_PIXEL_ID,
  };
}
